import _ from 'lodash';

export default function selector(storeState, props) {
    const { isDeleteDealsModalOpen, ...modalState } = _.get(storeState, 'deleteDealModal');
    return {
        isOpen: isDeleteDealsModalOpen,
        ...modalState,
    };
}
